import { MyHttpClient } from '../http-client';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client";
export var SLAB_APPROVAL_PREVIEW_KEY_PREFIX = 'slab-approval-preview:';
var SlabApprovalRequestsService = /** @class */ (function () {
    function SlabApprovalRequestsService(http) {
        this.http = http;
        this.baseUrl = environment.server + "/api/slab-approval-requests";
    }
    SlabApprovalRequestsService.prototype.fetchApprovalRequestById = function (requestId) {
        return this.http.get(this.baseUrl + "/" + requestId)
            .pipe(map(function (res) { return res.data || res.response || res; }))
            .pipe(catchError(this.handleError));
    };
    SlabApprovalRequestsService.prototype.fetchApprovalRequests = function (params) {
        var query = new URLSearchParams({
            pageNumber: String(params.pageNumber),
            pageLimit: String(params.pageLimit),
        });
        if (params.requestStatus) {
            query.set('requestStatus', params.requestStatus);
        }
        if (params.sortBy) {
            query.set('sortBy', params.sortBy);
            query.set('sortOrder', String(params.sortOrder == null ? -1 : params.sortOrder));
        }
        return this.http.get(this.baseUrl + "?" + query.toString())
            .pipe(map(function (res) {
            var rows = res.data || res.response || [];
            return {
                data: rows,
                documentCount: res.documentCount != null ? res.documentCount : rows.length,
            };
        }))
            .pipe(catchError(this.handleError));
    };
    SlabApprovalRequestsService.prototype.storePreviewForRequest = function (requestId, context) {
        var payload = context.newValue != null
            ? context
            : { requestId: requestId, newValue: context };
        sessionStorage.setItem("" + SLAB_APPROVAL_PREVIEW_KEY_PREFIX + requestId, JSON.stringify(payload));
    };
    SlabApprovalRequestsService.prototype.approveRequest = function (requestId, body) {
        return this.http.post(this.baseUrl + "/" + requestId + "/approve", body)
            .pipe(map(function (res) { return res; }))
            .pipe(catchError(this.handleError));
    };
    SlabApprovalRequestsService.prototype.rejectRequest = function (requestId, body) {
        return this.http.post(this.baseUrl + "/" + requestId + "/reject", body)
            .pipe(map(function (res) { return res; }))
            .pipe(catchError(this.handleError));
    };
    SlabApprovalRequestsService.prototype.handleError = function (error) {
        console.error('Failed to fetch slab approval requests', error);
        return throwError(error);
    };
    SlabApprovalRequestsService.ngInjectableDef = i0.defineInjectable({ factory: function SlabApprovalRequestsService_Factory() { return new SlabApprovalRequestsService(i0.inject(i1.MyHttpClient)); }, token: SlabApprovalRequestsService, providedIn: "root" });
    return SlabApprovalRequestsService;
}());
export { SlabApprovalRequestsService };
